import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import { Payment } from "@/models";

const state = {
  paymentPlans: [],
  paymentPlansLoading: false,
  paymentHistories: [],
  paymentHistoriesLoading: false,
  paymentHistory: {},
  paymentHistoryLoading: false,
  promoCode: {},
  promoCodeValidation: {},
  promoCodeLoading: false,
  payment: new Payment({}),
  paymentLoading: false,
  initializePayment: {}
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
